// frontend/src/components/ScientificAnalysis/ScientificAnalysis.tsx

import React, { useEffect } from 'react';
import { useAnalysis } from '../../hooks/useAnalysis';
import { useAuth } from '../../contexts/AuthContext';
import { DatasetSelector } from './DatasetSelector';
import { DatasetStats } from './DatasetStats';
import { AlertsList } from './AlertsList';
import { ColumnTable } from './ColumnTable';
import './ScientificAnalysis.css';

export const ScientificAnalysis: React.FC = () => {
  const { selectedTraceId, selectedDataset: authDatasetName } = useAuth();
  
  const {
    datasets,
    selectedDataset,
    analysis,
    loading,
    error,
    selectDataset,
    listDatasets,
  } = useAnalysis();

  useEffect(() => {
    listDatasets();
  }, [listDatasets]);

  if (loading && !analysis) {
    return (
      <div className="scientific-container">
        <div className="loading-state">🔬 Carregando dados...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="scientific-container">
        <div className="error-state">❌ {error}</div>
      </div>
    );
  }

  // Se temos um trace selecionado globalmente e o dataset ainda não foi carregado
  if (selectedTraceId && !analysis) {
    return (
      <div className="scientific-container">
        <div className="loading-state">⏳ Carregando análise do dataset selecionado...</div>
      </div>
    );
  }

  return (
    <div className="scientific-container">
      <div className="scientific-header">
        <h1>🔬 Análise Científica</h1>
        <p className="subtitle">Análise exploratória de dados com visão científica</p>

        {selectedDataset?.trace_id && (
          <div className="trace-badge">
            <span className="label">Trace ID:</span>
            <code>{selectedDataset.trace_id}</code>
          </div>
        )}
      </div>

      {/* Só exibe o seletor se NÃO houver trace selecionado globalmente */}
      {!selectedTraceId ? (
        <DatasetSelector
          datasets={datasets}
          selectedDataset={selectedDataset}
          onSelect={selectDataset}
          loading={loading}
        />
      ) : (
        <div style={{
          background: 'rgba(79, 195, 247, 0.1)',
          border: '1px solid #4fc3f7',
          borderRadius: '8px',
          padding: '12px 16px',
          marginBottom: '24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          color: '#4fc3f7',
        }}>
          <div>
            <span>Dataset em foco: <strong>{analysis?.dataset_name || selectedDataset?.dataset_name || authDatasetName || 'Carregando...'}</strong></span>
            <div style={{ fontSize: '11px', marginTop: '4px', color: '#8899aa' }}>
              Para alterar o dataset, acesse a tela "Meus Dados".
            </div>
          </div>
        </div>
      )}

      {analysis && (
        <>
          <DatasetStats analysis={analysis} />
          <AlertsList nullAnalysis={analysis.null_analysis} />
          <ColumnTable columnsMetadata={analysis.columns_metadata} />
        </>
      )}
    </div>
  );
};

// Garante as duas formas de exportação (named e default)
export default ScientificAnalysis;